export default __webpack_public_path__ + "static/media/ic_chat.02812447.svg";